export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7534.43e41828.jpg";